import { clsx } from 'clsx'
import { type FC } from 'react'

import { Modal } from 'base-ui'

import {
  DrawerTransition,
  UnstyledCssTransition,
} from '../../../../../../drawer-transition'
import { Loading } from '../../../../../../loading'

import { StoryblokCategoryNavigationContent } from './StoryblokCategoryNavigationContent'
import { useCategoriesNavigationContext } from './StoryblokCategoryNavigationProvider'

import style from './StoryblokCategoryNavigationSlider.module.css'

export const StoryblokCategoryNavigationSlider: FC = () => {
  const {
    animationDirection,
    currentCategoryData,
    handleClose,
    isLoading,
    isOpen,
    previouseCategoryData: previousCategoryData,
  } = useCategoriesNavigationContext()

  return (
    <Modal
      className="flex flex-col items-start justify-start"
      closeAfterTransition
      data-qa-id="kategories-navigation"
      onClose={handleClose}
      open={isOpen}
    >
      <DrawerTransition
        className="flex h-dvh w-full flex-col overflow-y-auto rounded-l-none bg-light-primary-medium outline-none tablet:max-w-screen-tablet tablet:rounded-r-m"
        direction="left"
        in={isOpen}
      >
        <div className="relative size-full">
          {isLoading ? <Loading className="absolute" /> : null}
          {currentCategoryData ? (
            <UnstyledCssTransition
              className={clsx(
                style['storyblok-category-navigation-slider'],
                animationDirection === 'backward' &&
                  style['storyblok-category-navigation-slider_backward-enter'],
                animationDirection === 'forward' &&
                  style['storyblok-category-navigation-slider_forward-enter'],
              )}
              enterClassName={clsx(
                animationDirection === 'backward' &&
                  style[
                    'storyblok-category-navigation-slider_backward-enter-active'
                  ],
                animationDirection === 'forward' &&
                  style[
                    'storyblok-category-navigation-slider_forward-enter-active'
                  ],
              )}
              in={Boolean(currentCategoryData)}
              key={`slide-code-current${currentCategoryData.akeneoCategoryCode}`}
            >
              <StoryblokCategoryNavigationContent
                categoryData={currentCategoryData}
              />
            </UnstyledCssTransition>
          ) : null}
          {previousCategoryData ? (
            <UnstyledCssTransition
              className={clsx(
                style['storyblok-category-navigation-slider'],
                animationDirection === 'backward' &&
                  style['storyblok-category-navigation-slider_backward-leave'],
                animationDirection === 'forward' &&
                  style['storyblok-category-navigation-slider_forward-leave'],
              )}
              enterClassName={clsx(
                animationDirection === 'backward' &&
                  style[
                    'storyblok-category-navigation-slider_backward-leave-active'
                  ],
                animationDirection === 'forward' &&
                  style[
                    'storyblok-category-navigation-slider_forward-leave-active'
                  ],
              )}
              in={Boolean(previousCategoryData) && Boolean(currentCategoryData)}
              key={`slide-code-previous${previousCategoryData.akeneoCategoryCode}`}
            >
              <StoryblokCategoryNavigationContent
                categoryData={previousCategoryData}
              />
            </UnstyledCssTransition>
          ) : null}
        </div>
      </DrawerTransition>
    </Modal>
  )
}
